/**
 * @file accident模块路由配置
 */

// 司机确认事故
const driverConfirmAccident = (resolve) =>
  import(
    /* webpackChunkName: "accident" */ '../views/accident/driver-confirm-accident.vue'
  );
// 货主确认事故
const ownerConfirmAccident = (resolve) =>
  import(
    /* webpackChunkName: "accident" */ '../views/accident/owner-confirm-accident.vue'
  );

export default [
  {
    name: 'driver-confirm-accident',
    path: '/accident/driver-confirm-accident',
    component: driverConfirmAccident,
    meta: { title: '确认事故', keepAlive: true },
  },
  {
    name: 'owner-confirm-accident',
    path: '/accident/owner-confirm-accident',
    component: ownerConfirmAccident,
    meta: { title: '确认事故', keepAlive: true },
  },
];
